<div class="">
	<!-- Message de succès -->
	<div *ngIf="success" class="bg-green-50 border border-green-200 rounded-md p-4 mb-6">
		<div class="flex">
			<div class="flex-shrink-0">
				<svg class="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">
					<path fill-rule="evenodd"
						d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
						clip-rule="evenodd" />
				</svg>
			</div>
			<div class="ml-3">
				<p class="text-sm text-green-800">Sous-compte créé avec succès !</p>
			</div>
		</div>
	</div>

	<!-- Message d'erreur -->
	<div *ngIf="error" class="bg-red-50 border border-red-200 rounded-md p-4 mb-6">
		<div class="flex">
			<div class="flex-shrink-0">
				<svg class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
					<path fill-rule="evenodd"
						d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
						clip-rule="evenodd" />
				</svg>
			</div>
			<div class="ml-3">
				<p class="text-sm text-red-800">{{ error }}</p>
			</div>
		</div>
	</div>

	<form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">
		<!-- Informations personnelles -->
		<div>
			<div class="grid grid-cols-1 md:grid-cols-2 gap-4">
				<!-- Prénom -->
				<div>
					<label for="firstName" class="block text-sm font-medium text-gray-700 mb-1">
						Prénom *
					</label>
					<input type="text" id="firstName" formControlName="firstName"
						class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm placeholder:text-gray-300"
						[class.border-red-500]="isFieldInvalid('firstName')" [class.border-green-500]="isFieldValid('firstName')"
						placeholder="Prénom">
					<p *ngIf="isFieldInvalid('firstName')" class="mt-1 text-sm text-red-600">
						{{ getErrorMessage('firstName') }}
					</p>
				</div>

				<!-- Nom -->
				<div>
					<label for="lastName" class="block text-sm font-medium text-gray-700 mb-1">
						Nom *
					</label>
					<input type="text" id="lastName" formControlName="lastName"
						class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm placeholder:text-gray-300"
						[class.border-red-500]="isFieldInvalid('lastName')" [class.border-green-500]="isFieldValid('lastName')"
						placeholder="Nom">
					<p *ngIf="isFieldInvalid('lastName')" class="mt-1 text-sm text-red-600">
						{{ getErrorMessage('lastName') }}
					</p>
				</div>

				<!-- Sexe -->
				<div>
					<label for="sex" class="block text-sm font-medium text-gray-700 mb-1">
						Sexe *
					</label>
					<select id="sex" formControlName="sex"
						class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm placeholder:text-gray-300"
						[class.border-red-500]="isFieldInvalid('sex')" [class.border-green-500]="isFieldValid('sex')">
						<option value="">Sélectionner</option>
						<option value="male">Homme</option>
						<option value="female">Femme</option>
					</select>
					<p *ngIf="isFieldInvalid('sex')" class="mt-1 text-sm text-red-600">
						{{ getErrorMessage('sex') }}
					</p>
				</div>

				<!-- Date de naissance -->
				<div>
					<label for="birthday" class="block text-sm font-medium text-gray-700 mb-1">
						Date de naissance *
					</label>
					<input type="date" id="birthday" formControlName="birthday"
						class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm placeholder:text-gray-300"
						[class.border-red-500]="isFieldInvalid('birthday')" [class.border-green-500]="isFieldValid('birthday')"
						[max]="getTodayDate()" (change)="onBirthdayChange()">
					<p *ngIf="isFieldInvalid('birthday')" class="mt-1 text-sm text-red-600">
						{{ getErrorMessage('birthday') }}
					</p>
				</div>
			</div>
		</div>

		<!-- Nationalité -->
		<div>
			<div>
				<label for="nationality" class="block text-sm font-medium text-gray-700 mb-1">
					Nationalité *
				</label>
				<select id="nationality" formControlName="nationality"
					class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm placeholder:text-gray-300"
					[class.border-red-500]="isFieldInvalid('nationality')" [class.border-green-500]="isFieldValid('nationality')"
					[disabled]="loadingCountries">
					<option value="">Sélectionner une nationalité</option>
					<option *ngFor="let country of countries" [value]="country.code">
						{{ country.name_fr }}
					</option>
				</select>
				<p *ngIf="isFieldInvalid('nationality')" class="mt-1 text-sm text-red-600">
					{{ getErrorMessage('nationality') }}
				</p>
				<div *ngIf="loadingCountries" class="mt-1 text-sm text-gray-500">
					Chargement des pays...
				</div>
			</div>
		</div>

		<!-- Boutons d'action -->
		<div class="flex justify-end space-x-3 pt-6 border-t border-gray-200">
			<button type="button" (click)="closeModal()"
				class="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 text-sm">
				Annuler
			</button>
			<button type="submit" [disabled]="loading || !form.valid"
				class="px-4 py-2 bg-primary text-white rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed text-sm">
				<span *ngIf="loading" class="inline-flex items-center">
					<svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
						<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
						<path class="opacity-75" fill="currentColor"
							d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
						</path>
					</svg>
					Création...
				</span>
				<span *ngIf="!loading">Créer le sous-compte</span>
			</button>
		</div>
	</form>
</div>